// extracted by mini-css-extract-plugin
export var centerText = "_gb-8";
export var container = "_gb-0";
export var doughnutContainer = "_gb-7";
export var legend = "_gb-a";
export var legendItemColorDisplay = "_gb-b";
export var legendItemLabel = "_gb-d";
export var legendItemValue = "_gb-c";
export var lg = "_gb-5";
export var maxWidth = "_gb-9";
export var md = "_gb-4";
export var responsive = "_gb-6";
export var sm = "_gb-3";
export var xs = "_gb-2";
export var xxs = "_gb-1";